import React, { Component } from 'react';
import PropTypes from 'prop-types';
import store from 'store';
import { Analytics } from 'packages';
/**
 * @description
 * @class Alert
 * @extends {Component}
 */
class Alert extends Component {
    state = {
        dismissed: false
    };

    dismiss = e => {
        e.preventDefault();
        const { storageKey, dismissible, name } = this.props;
        if (!dismissible) {
            // eslint-disable-next-line
            console.error(
                'You are trying to dimiss an alert that does not have the dismiss prop'
            );
            return;
        }

        store.set(storageKey, 'true');
        this.setState({
            dismissed: true
        });
        if (name) {
            Analytics.trackEvent({
                category: 'Alert',
                action: 'Dismiss',
                label: `Alert: ${name}`
            });
        }
    };
    render() {
        const { classNames, render, zIndex } = this.props;
        const { dismissed } = this.state;
        return dismissed === false ? (
            <div
                style={{ zIndex: zIndex }}
                className={`alert ${classNames} ${
                    dismissed ? 'hide' : 'show'
                } `}>
                {render(this.dismiss)}
            </div>
        ) : null;
    }
}

Alert.propTypes = {
    classNames: PropTypes.string,
    zIndex: PropTypes.number,
    dismissible: PropTypes.bool.isRequired,
    storageKey: PropTypes.string,
    render: PropTypes.func.isRequired
};

export default Alert;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/alert/alert.jsx